/* Magic Pillow extras: scroll-based sticky add-to-cart (robust fallback to IntersectionObserver) */
(function () {
  function init() {
    var sticky = document.querySelector('[data-mp-sticky]');
    var anchor = document.querySelector('[data-mp-form] [data-mp-atc]');
    if (!sticky || !anchor) return;
    var footer = document.querySelector('.mp-footer');
    var ticking = false;
    function check() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      var nearFoot = footer && footer.getBoundingClientRect().top < window.innerHeight - 40;
      sticky.classList.toggle('is-visible', r.bottom < 0 && !nearFoot);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Magic Pillow geo-currency: switch visitors to their own market (e.g. US -> USD) once per session,
   using Shopify's IP-based browsing context suggestions. Never overrides a manual choice. */
(function () {
  try {
    var S = window.Shopify || {};
    if (S.designMode || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
    if (/[?&](currency|country)=/i.test(location.search)) return;
    if (document.cookie.indexOf('mp_geo_choice=') > -1) return;
    var ss = null; try { ss = window.sessionStorage; } catch (e) { }
    if (ss && ss.getItem('mp_geo_checked')) return;
    if (ss) ss.setItem('mp_geo_checked', '1');
    fetch('/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var det = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        var sug = d && d.suggestions && d.suggestions[0] && d.suggestions[0].parts && d.suggestions[0].parts.country;
        var opts = (sug && sug.options) || {};
        if (!det || det === S.country || !opts[det]) return;
        var f = document.createElement('form');
        f.method = 'post'; f.action = '/localization'; f.style.display = 'none';
        var fields = { form_type: 'localization', utf8: '✓', _method: 'put', country_code: det, return_to: location.pathname + location.search };
        Object.keys(fields).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; f.appendChild(i); });
        document.body.appendChild(f); f.submit();
      })
      .catch(function () { });
  } catch (e) { }
})();

/* Remember a manual country choice from the footer selector so the geo switch never fights it */
document.addEventListener('submit', function (e) {
  if (e.target && e.target.matches && e.target.matches('.mp-loc')) {
    document.cookie = 'mp_geo_choice=1;path=/;max-age=31536000;samesite=lax';
  }
});
